export const FLEX_COLUMN_GAP = 24;
